@for (cartItem of cartItems$ | async; track cartItem.id) {
  <app-cart-item
    [item]="cartItem"
    [editable]="false"
    [checkoutPage]="true"></app-cart-item>
}
@if (taxEstimate$ | async; as tax) {
  <se-fe-card>
    <div class="tax tax-display">
      <span>Tax:</span>
      <span class="amount">{{ tax.totalEstimatedTax }}</span>
    </div>
  </se-fe-card>
}
